import { LitElement, css, html } from 'lit';
import { customElement, query } from 'lit/decorators';

import { StateController } from '../../../helpers/state/state-management/state-controller';
import { dispatchSettingsUpdate } from '../../../helpers/settings';
import { isDefined } from '../../../helpers/utils';
import topicData from '../../../helpers/state/topic-data';

@customElement('allow-upvoting')
export class AllowUpvoting extends LitElement {
    @query('#upvote')
    upvoteElement?: HTMLInputElement;

	private readonly bindTopicState = new StateController(this, topicData);

    firstUpdated() {
        if(isDefined(this.upvoteElement)) {
            this.upvoteElement.checked = topicData.topic?.has_likes ?? false;
        }
    }

	toggleUpvote(e: Event) {
        const canUpvote = (e.target as HTMLInputElement).checked;

        dispatchSettingsUpdate(
            {
				updatedValue: canUpvote,
				field: 'has_likes',
            },
            this
        );
	}

    render() {
        return html`
            <h4 class="helpSubHeader">Enable "upvoting"</h4>
            <p>
                Selecting this allows map viewers and contributors to "upvote" points. The total
                "upvotes" appear on the point card for everyone to see.
            </p>
            <div class="setting-switch">
                <label class="switch-label" for="upvote">Do not allow Upvotes</label>
                <form-switch class="switch-icon" id="upvote" name="upvote" @change=${this.toggleUpvote}></form-switch>
                <label class="switch-label" for="upvote">Allow Upvotes</label>
            </div>
        `;
    }

    static get styles() {
        return css`
            .setting-switch {
                display: grid;
                grid-auto-flow: column;
                grid-auto-columns: 1fr;
                align-items: center;
                justify-content: space-evenly;
            }

            .switch-label {
                text-align: center;
            }

            .switch-icon {
                margin-left: auto;
                margin-right: auto;
            }

            .helpSubHeader {
                margin-bottom: 0px;
                font-size: 0.75rem;
                color: var(--theme-input-color);
            }
        `;
    }
}
